<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/yongxin/equipment/feed/report/page" getKey="rows" :columns="columns" @selectionChange="selectionChange">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('touliaoshijian')">
            <yi_time_input format="yyyy-MM-dd HH:mm:ss" value-format="timestamp" type="datetimerange" :start.sync="yt.conditions.feedStartTime" :end.sync="yt.conditions.feedEndTime"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select multiple type="equipment" :placeholder="$t('suoyoushebei')" :ids.sync="yt.conditions.equipmentIds"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('touliaowuliaomingcheng')">
            <yi_dictionary_select type="FEED_MATERIAL_NAME" :ids.sync="yt.conditions.feedMaterialCode"></yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="reset">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button :loading="loading" size="mini" type="primary" @click="getExportData" v-if="utils.checkPower('web_report_yongxin_equipment_feed_report_export')">
          {{$t('daochu')}}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
import dayjs from 'dayjs';
// 获取当月 1 号 0 点的时间戳
const startOfMonth = dayjs()
  .startOf('month')
  .valueOf();
// 获取当月月末 23 点 59 分 59 秒的时间戳
const endOfMonth = dayjs()
  .endOf('month')
  .endOf('day')
  .valueOf();

export default {
  name: 'web_customize_yongxin_report_equipment_feed_report_list',
  data() {
    return {
      loading:false,
      conditions: {
        feedStartTime: startOfMonth,
        feedEndTime: endOfMonth
      },
      columns: [
        {
          label: 'shebeiSN',
          prop: 'equipmentInfo.sn'
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipmentInfo.name'
        },
        {
          label: 'touliaoshijian',
          prop: 'feedTime',
          type: 'time'
        },
        {
          label: 'touliaowuliaomingcheng',
          prop: 'feedMaterialCode',
          type: 'dictionary',
          key: 'FEED_MATERIAL_NAME'
        },
        {
          label: 'touliaozhongliang(KG)',
          prop: 'feedWeight'
        },
        {
          label: 'liaodou',
          prop: 'feedEquipmentInfo.sn'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = this.utils.copy(this.conditions);
      this.yt.get(1);
    }, 300);
  },
  methods: {
    // 重置
    reset() {
      this.yt.clear(this.conditions);
    },

    getExportData() {
      this.loading = true;

      this.http.post(`/custom/yongxin/equipment/feed/report/export` , this.yt.conditions )
          .then(res => {
            const fileId = res.data;

            if (!fileId) {
              this.utils.errorMessage(this.$t('wufaxiazaiwenjian'));
              this.loading = false;
              return;
            }

            return this.http.get('/web/customer/files/download?id=' + fileId)
                .then(fileRes => {
                  let baseUrl = fileRes.data;

                  if (baseUrl) {
                    window.open(baseUrl);
                  } else {
                    this.utils.errorMessage(this.$t('wenjianlianjieweikong'));
                  }
                  this.loading = false;
                })
                .catch(error => {
                  this.utils.errorMessage(error);
                });
          })
          .catch(error => {
            this.loading = false;
            this.utils.errorMessage(error);
          });
    }
  }
};
</script>
